module.exports = __webpack_public_path__ + "img/spoken_index_score_1.7372e390.png";